<template>
  <footer class="footer">
    <div class="footer__content">
      <a-footer-address />
      <a-footer-navigation />
      <a-footer-social />
    </div>
  </footer>
</template>

<script>
import AFooterAddress from '@/components/singletons/atoms/AFooterAddress'
import AFooterNavigation from '@/components/singletons/atoms/AFooterNavigation'
import AFooterSocial from '@/components/singletons/atoms/AFooterSocial'

export default {
  name: 'SFooter',

  components: {
    AFooterAddress,
    AFooterNavigation,
    AFooterSocial
  }
}
</script>

<style scoped>
.footer {
  position: relative;
  margin-top: 5vw;
  padding: var(--grid-spacing) 0;

  font-size: 14px;

  background: #fff;
}

@media (min-width: 1030px) {
  .footer {
    margin-top: 50px;
  }
}

.footer::before {
  content: "";

  position: absolute;
  height: 5vw;
  left: 0;
  right: 0;
  bottom: 100%;

  background:
    var(--color-background)
    url("~@/assets/footer-wave.svg") center / 100% 100% no-repeat;
}

@media (min-width: 1030px) {
  .footer::before {
    height: 50px;
  }
}

.footer__content {
  display: grid;
  grid-gap: var(--grid-spacing);
  width: var(--container-width);
  max-width: 100%;
  margin: 0 auto;
  padding: 0 var(--container-padding);
}

@media (min-width: 600px) {
  .footer__content {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
